import _ from 'lodash';

/**
 * This file registers an hook with the TransitionsService which protects a
 * route that requires a specific environment.
 */
export const requiresStage = ($state, $transitions) => {
  'ngInject';

  // Matches if the destination state's data property has a truthy 'requiresStage' property
  const requiresStageCriteria = {
    to: (state) => state.data && state.data.requiresStage
  };

  // Function that returns a redirect for the current transition to the home state
  // if the stage does not match one in the given stages array
  const redirectToHome = (trans) => {
    let envService = trans.injector().get('envService');
    let { requiresStage } = trans.$to().data;
    if (!_.includes(requiresStage, envService.getStage())) {
      return $state.target('app.home', undefined, { location: true });
    }
  };

  // Register the "requires stage" hook with the TransitionsService
  $transitions.onBefore(requiresStageCriteria, redirectToHome, { priority: 11 });
}
